import { render, staticRenderFns } from "./NavItems.vue?vue&type=template&id=08139ba4&scoped=true&"
import script from "./NavItems.vue?vue&type=script&lang=js&"
export * from "./NavItems.vue?vue&type=script&lang=js&"
import style0 from "./NavItems.vue?vue&type=style&index=0&id=08139ba4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08139ba4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
